import * as TYPES from './types';

const initialState = {
  list: [],
  fetching: false,
  errorMessages: null,
  total: 0,
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case TYPES.GET_CONCRETE_CLASSES_STATISTICAL_REQUEST:
      return {
        ...state,
        fetching: true,
        errorMessages: null,
      };

    case TYPES.GET_CONCRETE_CLASSES_STATISTICAL_SUCCESS:
      return {
        ...state,
        list: payload.data,
        total: payload.total || payload.data.length,
        fetching: false,
      };

    case TYPES.GET_CONCRETE_CLASSES_STATISTICAL_ERROR:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
      };

    default:
      return state;
  }
}
